import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ServicioInteropereabilidadRequestService {

  private REPORTES_API: string = '';

  constructor(private http: HttpClient) {
    this.REPORTES_API = environment.API_REPORTES;
  }

  /*
  Este método tiene la ruta principal de los servicios, la cual
  enrutará al servicio necesario, dependiendo de la petición del cliente.
  */
  public getRequest(request: string, params: any) {
    const URL = `${this.REPORTES_API}/${request}`;
    return this.http.post(
      URL,
      {
        ...params,
      },
      { headers: { 'Content-Type': 'application/json' } }
    );
  }
}
